import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ITrackerGroupsTrackersListResponse } from '../types';
import {
  AFFILIATE_SHOW_TRACKERS_LIST_API_URL,
  AFFILIATE_SHOW_TRACKERS_LIST_QUERY,
  AFFILIATES_TRACKER_GROUPS_PERMISSIONS,
} from '../constants';

export default function useShowAffiliateTrackersListQuery(id: Ref<number>): IContextQueryResult<ITrackerGroupsTrackersListResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ITrackerGroupsTrackersListResponse>({
    queryKey: [AFFILIATE_SHOW_TRACKERS_LIST_QUERY, id],
    queryFn: ({ signal }) => fetchGet<ITrackerGroupsTrackersListResponse>(
      AFFILIATE_SHOW_TRACKERS_LIST_API_URL,
      {
        signal,
        permission: AFFILIATES_TRACKER_GROUPS_PERMISSIONS.SHOW,
        queryParams: {
          'history_of_tracker_groups_change[affiliate_id]': id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
